import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Routes } from '@/routes';
import { PageError, RetryAlert } from '@/components';

export default function ErrorNoValidPreRegister({ title = undefined, page = false }) {

  const navigate = useNavigate();
  const [t] = useTranslation(['common', 'dormitory']);

  const toDormitory = useCallback(() => {
    navigate(Routes.Dormitory);
  }, [navigate]);

  const actionText = t('common:labels.back');
  const errorMessage = t('dormitory:errors.no-valid-pre-register');

  if (!page) {
    return (
      <PageError
        title={title}
        action={toDormitory}
        actionText={actionText}
        content={errorMessage}
      />
    );
  }

  return (
    <RetryAlert
      noIcon
      action={toDormitory}
      actionText={actionText}
      content={errorMessage}
    />
  );

}
